import React, { useState } from 'react';
import './NotifySection.css';

const NotifySection = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!email || !email.includes('@')) return;
    setSubmitted(true);
    setEmail('');
  };

  return (
    <div className="notify-section" id="notify">
      <div className="notify-inner">
        <div className="notify-text reveal">
          <h2>Be first when<br/>features go live</h2>
          <p>Drop your email and we'll notify you the moment each payment feature activates — no spam, just milestones.</p>
        </div>
        <div className="notify-form reveal rd2">
          <input className="notify-input" type="email" placeholder="Enter your email address" value={email} onChange={e => setEmail(e.target.value)} />
          <button className="notify-btn" onClick={handleSubmit} disabled={submitted} style={submitted ? {background:'var(--success)'} : {}}>
            {submitted ? '✓ You\'re on the list!' : 'Notify Me →'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotifySection;
